/* Original EZ-ROPE twisted strands and scroll-following climber, scoped per section. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ezr-timeline]').forEach(section => {
      if (section.dataset.ezrReady) return;
      section.dataset.ezrReady = 'true';
      const timeline = section.querySelector('.ezr-tl-timeline');
      const svg = timeline.querySelector('.ezr-tl-rail');
      const paths = Array.from(svg.querySelectorAll('path'));
      const rider = timeline.querySelector('.ezr-tl-rider');
      const chapters = Array.from(timeline.querySelectorAll('[data-label]'));
      const links = Array.from(section.querySelectorAll('.ezr-tl-dot'));
      const label = section.querySelector('.ezr-tl-nav-label');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      let frame = 0;
      let active = -1;
      function draw() {
        frame = 0;
        const rect = timeline.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (innerHeight * .85 - rect.top) / (rect.height + innerHeight * .3)));
        paths.forEach(path => { path.style.strokeDashoffset = motion.matches ? '0' : path.dataset.len * (1 - progress); });
        if (!motion.matches && paths[1].dataset.len) {
          const pt = paths[1].getPointAtLength(paths[1].dataset.len * progress);
          rider.style.transform = `translate(${pt.x - 22}px,${pt.y - 26}px)`;
          rider.style.opacity = progress > .005 && progress < .995 ? '1' : '0';
        } else rider.style.opacity = '0';
        const index = chapters.reduce((best, chapter, i) => chapter.getBoundingClientRect().top < innerHeight * .6 ? i : best, 0);
        if (index !== active) {
          active = index;
          links.forEach((link, i) => { link.classList.toggle('is-active', i === index); if (i === index) link.setAttribute('aria-current', 'step'); else link.removeAttribute('aria-current'); });
          label.textContent = chapters[index].dataset.label;
        }
      }
      function build() {
        const h = timeline.offsetHeight;
        const w = svg.getBoundingClientRect().width || 44;
        const cx = w / 2, amp = Math.min(7.5, w * .18);
        svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
        svg.setAttribute('height', h);
        svg.setAttribute('width', w);
        function strand(phase) {
          let d = `M ${cx + amp * Math.sin(phase)} 0`;
          for (let y = 0; y <= h; y += 4) d += ` L ${(cx + amp * Math.sin(y / 28 * Math.PI + phase)).toFixed(1)} ${y}`;
          return d;
        }
        const a = strand(0), b = strand(Math.PI);
        paths.forEach((path, i) => {
          path.setAttribute('d', i === 2 ? b : a);
          path.dataset.len = path.getTotalLength();
          path.style.strokeDasharray = path.dataset.len;
        });
        rider.style.left = `${svg.getBoundingClientRect().left - timeline.getBoundingClientRect().left}px`;
        draw();
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(draw); }
      window.addEventListener('scroll', schedule, {passive:true, signal:controller.signal});
      motion.addEventListener('change', draw, {signal:controller.signal});
      const resize = new ResizeObserver(build);
      resize.observe(timeline);
      window.addEventListener('resize', build, {passive:true, signal:controller.signal});
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(section)) return;
        controller.abort(); resize.disconnect(); cancelAnimationFrame(frame);
      }, {signal:controller.signal});
      build();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
